<template>
    <b-dropdown
        id="dropdown-form"
        text="Colunas"
        ref="dropdown"
        class="my-2"
        variant="light"
        style="border: 1px solid #729eff; z-index: 3"
        >
        <template v-for="(field,i) in fields">
            <template v-if="field.key != 'selecionar'">
                <b-dropdown-item-button @click="$emit('toggleColuna', i)" :key="i">
                    <label><input type="checkbox" ref="chk" :checked="showColumn(i)" /> {{ field.label }}</label>
                </b-dropdown-item-button>
            </template>
        </template>
    </b-dropdown>
</template>

<script>
export default {
    props: ['fields', 'showColunms'],
    methods: {
        showColumn(i) {
            return this.showColunms.includes(i) ? true : false
        },
    }
}
</script>

<style>

</style>
